module.exports = __webpack_public_path__ + "static/img/10045B_2_R_20201004_LC.9bbb83d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10045B_2_R_20201004_LC.png
// module id = 9/W9
// module chunks = 0